module.exports = __webpack_public_path__ + "static/img/join2.8627888.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/join2.png
// module id = rbpQ
// module chunks = 24